// extracted by mini-css-extract-plugin
export default {"question":"Question_question__CRLAL","answerContainer":"Question_answerContainer__Az7+D","questionHeader":"Question_questionHeader__dT+P7"};